import { Toaster as Sonner } from 'sonner';

// Mount once at the App root. Operator UI feedback for mutations (snooze
// applied, signal created, config saved, etc.) goes through sonner's
// toast() / toast.error() / toast.success() — see lib/toast.ts wrapper.
//
// Theme is locked to "dark" because the Trader Pro palette is dark-only;
// sonner picks up our CSS variables for surface + foreground.
export function Toaster() {
  return (
    <Sonner
      theme="dark"
      position="bottom-right"
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast: 'border border-border bg-card text-card-foreground shadow-lg',
          description: 'text-muted-foreground',
          actionButton: 'bg-primary text-primary-foreground',
          cancelButton: 'bg-muted text-muted-foreground',
        },
      }}
    />
  );
}
